import { QueryClient } from '@tanstack/react-query';

/**
 * THE APP'S ONE QUERY CACHE — its own module so signing out can empty it.
 *
 * It lived in `App.tsx`, where nothing else could reach it, so `logout()` ended
 * the session and left every fetched answer in memory: the next person to sign
 * in on the same browser — a shared office PC, a site-office laptop — saw the
 * previous user's rosters, pay figures and approvals until each query happened
 * to refetch. `authStore.logout` now clears it (2026-09-25).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});
